import { SecurityGraphFilters } from 'containers/Visibility/SecurityGraphNext/Components/SecutiryGraphFilters';

export const PostureSidebar = () => {
  return <SecurityGraphFilters />;
};
